export const SITE_URL = "https://www.sustally.com";
export const SITE_NAME = "Sustally";
export const DEFAULT_OG_IMAGE = `${SITE_URL}/og-image.png`;

export const DEFAULT_TITLE =
  "Sustally | SaaS for Sustainability Impact Tracking";

export const DEFAULT_DESCRIPTION =
  "Sustally is a B2B SaaS platform that helps startups and MSMEs measure, manage, and share economic, environmental, social, and governance (EESG) impact with stakeholders.";

export const NOINDEX_PATHS = [
  "/employeepage",
  "/employeesignin",
  "/assessmentform",
  "/learningform",
  "/career/applicationForm",
  "/terms-service",
];
